import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ClientOrBusPageComponent } from './client-or-bus-page.component';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { MomentModule } from 'ngx-moment';
import { DeleteEntityModule } from 'src/app/shared/delete-entity/delete-entity.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.clientsOrBus',
    url: '/clientsOrBus',
    component: ClientOrBusPageComponent,
    data: {
      requireLogin: true
    }
  }
];

@NgModule({
  declarations: [ClientOrBusPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    SkeletonLoaderModule,
    DataTablesModule,
    DeleteEntityModule,
    MomentModule.forRoot({
      relativeTimeThresholdOptions: {
        'm': 59
      }
    }),
    UIRouterModule.forChild({ states })
  ],
  exports: [ClientOrBusPageComponent],
  entryComponents: [ClientOrBusPageComponent]
})
export class ClientOrBusPageModule { }
